import { apiFetch } from "@/api/fetch";

interface FeedbackPayload {
  session_id: string;
  is_high_quality_answer: boolean;
  feedback_text?: string | null;
  quoted_texts?: string[] | null;
  tags?: string[] | null;
}

export const submitFeedback = async (
  payload: FeedbackPayload,
): Promise<void> => {
  const res = await apiFetch("/feedback/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    throw new Error("Failed to submit feedback");
  }
};
